var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.isReady)?_c('dashboard'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }